<template>
   <div class="cart">
      <span class="cart-size" @click="showCart = !showCart">{{ cartSize }}</span>
      <i class="fa fa-shopping-cart" @click="showCart = !showCart"></i>
      <br/>
      <div class="cart-items" v-show="showCart">
         <table class="cartTable">
            <tbody>
               <!-- 
                  First loop : on each product in cart
                  Second loop : on each addon in one product
                  WARNING : take care of ":key", in each loop, we have to have different keys, to avoid a "duplicate key" message
               -->
               <template v-for="(product,index) in cart">

                  <tr :key="product._pk">
                     <td class="align-left">
                        <div class="cartImage" v-if="options.indexOf('no_cancel')<0"
                           @click="removeProduct(product)" 
                           v-bind:style="{ backgroundImage: 'url('+product.image + ')' }" style="background-size: cover; background-position: center;"
                        >
                           <i class="close fa fa-times"></i>
                        </div>
                     </td>
                     <td class="align-center"><button v-if="options.indexOf('no_minus')<0" @click="quantityChange(product, 'decriment')"><i class="close fa fa-minus"></i></button></td>
                     <td class="align-center"><span v-if="options.indexOf('no_quantity')<0">{{ product.quantity }}</span></td>
                     <td class="align-center"><button v-if="options.indexOf('no_plus')<0" @click="quantityChange(product, 'incriment')"><i class="close fa fa-plus"></i></button></td>
                     <td class="align-left" width="150px">{{ product.product }}</td>
                     <td class="align-right" width="100px">{{ $n(product.price,'currency') }}</td>
                  </tr>
                  <template v-for="(addon,index) in product.addons">
                     <tr :key="index" v-if="index==0">
                        <td class="align-left">&nbsp;</td>
                        <td colspan="5"><small>Options :</small></td>
                     </tr>
                     <tr :key="addon._pk">
                        <td class="align-left">&nbsp;</td>
                        <td class="align-center"></td>
                        <td class="align-left" colspan="3" width="150px"><small>{{ addon.product }}</small></td>
                        <td class="align-right" width="100px">{{ $n(addon.price,'currency') }}</td>
                     </tr>
                  </template>
               </template>
            </tbody>
         </table>
      </div>
      <span v-show="showCart" class="align-right"> {{ $n(cartSubTotal,'currency') }}</span>
      <br/>
      <button class="clearCart" v-show="showCart" @click="clearCart()"> Clear Cart </button>
      <button class="checkoutCart" v-show="showCart" @click="propagateCheckout()"> Checkout </button>
   </div>
</template>

<script>
   import Vue from 'vue';
   import i18n from '@/plugins/i18n.js';

   export default {
      name: 'ddo-cart-area',

      components: {
      },

      props: {
         callbacks: {},
         checkoutBool: false,
         cart: Array,
         options: {},
         cartSubTotal2: null,
         tax: null,
         cartTotal: null,
      },

      data: () => {
         return {
            showCart: true,
         }
      },

   computed: {

      cartSize: function() {
         var cartSize = 0;
         for (var i=0; i<this.cart.length; i++) {
            if ( this.cart[i].quantity ) {
               cartSize += this.cart[i].quantity;
            }
         }
         return cartSize;
      },

      cartSubTotal: function() {
         var cartSubTotal = 0;
         for (var i=0; i<this.cart.length; i++) {
            if ( this.cart[i].quantity && this.cart[i].price ) {
               cartSubTotal += this.cart[i].quantity * this.cart[i].price;
            }
            if ( this.cart[i].addons.length>0 ) {
               for (var j=0; j<this.cart[i].addons.length; j++) {
                  cartSubTotal += this.cart[i].quantity * this.cart[i].addons[j].price;
               }
            }
         }
         return cartSubTotal;
      },

   },

      methods: {

         removeProduct() {
         },
         quantityChange() {
         },
         clearCart() {
            if ( this.callbacks.cart_clear ) {
               this.callbacks.cart_clear();
            }
         },
         propagateCheckout() {
         },
      },

   }
</script>

<style lang="scss">

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

$mobile: 600px;
$max-width: 80em;

@mixin aspect-ratio($width, $height) {
  position: relative;
  &:before {
    display: block;
    content: "";
    width: 100%;
    padding-top: ($height / $width) * 100%;
  }
  > .content {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }
}

@keyframes openUp {
  0% {
    transform: translate(-50%, -50%) scale(0.5);
  }

  100% {
    transform: translate(-50%, -50%) scale(1);
  }
}

button {
  appearance: none;
  padding: 0.5em;
  margin: 0.5em 0;
  background: white;
  border: 1px solid black;
  transition: all 0.1s;
  font-size: 14px;
  cursor: pointer;
  user-select: none;

  .fa {
    font-size: 1em !important;
    vertical-align: middle;
  }

  &:hover {
    color: white;
    background: black;
  }
}

input {
  display: inline-block;
  appearance: none;
  padding: 0.5em;
  margin: 0.5em 0.5em 0.5em 0;
  width: 50px;
  background: white;
  border: 1px solid black;
  transition: all 0.1s;
  font-size: 14px;
}

label {
  font-size: 0.75em;
  margin-right: 0.5em;
}

.checkout-area table {
  margin: 0 auto;
  padding: 0.5em;
  width: 100%;
  max-width: $max-width * 0.5;
  text-align: left;

  th, td {
    padding: 0 0.25em;
  }

  @media(max-width: $mobile) {
    th:nth-child(3), td:nth-child(3) {
      display: none;
    }
  }
}

.align-left {
  text-align: left;
}

.align-center {
  text-align: center;
}

.align-right {
  text-align: right;
}

.vert-bottom {
  vertical-align: bottom;
}

.vert-middle {
  vertical-align: middle;
}

.main-wrapper {
  .header {
    position: relative;
    background: linear-gradient(to left, #16222A , #3A6073);
    background-size: cover;
    height: 25em;
    width: 100vw;
    box-shadow: inset -1px -3px 5px rgba(0,0,0,0.5), inset 1px 3px 5px rgba(0,0,0,0.5);

    h1 {
      position: absolute;
      text-align: center;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      color: white;
      font-size: 3em;
      text-shadow: 1px 3px 5px rgba(0,0,0,0.5), -1px -3px 5px rgba(0,0,0,0.5);
    }
  }

  #vue {
    margin: 0 auto;
    padding: 0.5em;
    text-align: center;

    .cart {
      position: fixed;
      right: 0em;
      top: 0em;
      text-align: right;
      background: rgba(0,0,0,0.85);
      color: white;
      z-index: 1;

      .fa-shopping-cart, .cart-size {
        cursor: pointer;
        font-size: 1.25em;
        user-select: none;
      }

      .fa-shopping-cart {
        padding: 1em 1em 1em 0;
      }

      .cart-size {
        padding: 1em 0 1em 1em;
      }


      .cart-items {
        padding: 0 1em 2em 1em;

        .cartTable {
          width: 20em;
        }
        
        .cartImage {
          width: 4em;
          height: 4em;
          margin: 0.5em auto;
          position: relative;
          cursor: pointer;
          
          &:after {
            content: "";
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(0,0,0,0.25);
            transition: all 0.1s;
          }
          
          i {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            font-size: 1.5em;
            z-index: 1;
            transition: all 0.25s;
          }
          
          &:hover {
            i {
              text-shadow: 1px 2px 5px black;
            }
            
            &:after {
              background: rgba(0,0,0,0.5);
            }
          }
          
          &:active {
             i {
              text-shadow: 0px 0px 1px black;
            }
          }
        }

        .cartSubTotal {
          border-top: 1px solid white;
          font-size: 1.25em;
        }

        .clearCart {
          float: left;
          margin-top: 2em;
          margin-bottom: 1.25em;
        }
        
        .checkoutCart {
          float: right;
          margin-top: 2em;
          margin-bottom: 1.25em;
        }
      }
    }

    .products {
      margin: 0 auto;
      width: 100%;
      max-width: $max-width;

      .product {
        display: inline-block;
        margin: 0.75em;
        width: 100%;
        max-width: 18em;

        .image {
          width: 18em;
          height: 18em;
          margin-bottom: 0.5em;
          position: relative;
          overflow: hidden;
          cursor: pointer;
          transition: box-shadow 0.25s;

          @media(max-width: $mobile) {
            width: 100vw;
            height: 100vw;
          }

          &:before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(0,0,0,0.5);
            opacity: 0;
            transition: all 0.25s;
          }

          &:after {
            content: "\f00e";
            font-family: "FontAwesome";
            position: absolute;
            top: 250%;
            left: 50%;
            transform: translate(-50%, -50%);
            font-size: 5em;
            color: white;
            pointer-events: none;
            text-shadow: 0 0 5px rgba(0,0,0,0.5), 0 0 10px rgba(0,0,0,0.5); 
            transition: all 0.25s;
          }

          &:hover {
            box-shadow: 0 12px 15px 0 rgba(0,0,0,0.24),0 17px 50px 0 rgba(0,0,0,0.19);

            &:before {
              opacity: 1;
            }

            &:after {
              top: 50%;
            }
          }
        }

        .name {
          font-weight: bold;
          font-size: 1.25em;
        }

        .description {
          font-style: italic;
        }

        .price {
          font-weight: bold;
        }
      }
    }

    .modalWrapper {
      position: relative;

      .overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0,0,0,0.7);
        //cursor: pointer;
        z-index: 2;
      }

      .prevProduct, .nextProduct {
        position: fixed;
        color: white;
        font-size: 2em;
        cursor: pointer;
        top: 50%;
        transform: translateY(-50%);
        padding: 1em;
        user-select: none;
        z-index: 5;
      }

      .prevProduct {
        left: calc(50% - 9.5em);
      }

      .nextProduct {
        right: calc(50% - 9.5em);
      }

      .modal {
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background: white;
        padding: 2em;
        text-align: center;
        max-height: calc(100% - 2em);
        overflow-y: scroll;
        overflow-x: hidden;
        animation: openUp 0.1s;
        z-index: 3;
        backface-visibility: hidden;

        .close {
          position: fixed;
          top: -0.5em;
          right: -0.5em;
          cursor: pointer;
          padding: 1em;
        }

        .imageWrapper {
          width: 25em;
          height: 25em;
          margin: 0.5em auto;
          overflow: hidden;

          .image {
            width: 100%;
            height: 100%;
            transition: transform 0.2s;
            z-index: 4;
            cursor: crosshair;
          }
        }

        .additionalImages {
          display: flex;
          width: 100%;
          margin: 0 auto;
          text-align: center;

          .additionalImage {
            flex-grow: 1;
            margin: 0.5em 1em;
            position: relative;
            overflow: hidden;
            cursor: pointer;
            width: 25%;
            height: auto;
            @include aspect-ratio(16, 12);
            
            &:nth-of-type(1n) {
              margin-left: 0;
            }
            
            &:nth-of-type(4n) {
              margin-right: 0;
            }
          }
        }

        .name {
          font-weight: bold;
          font-size: 1.25em;
        }

        .description {
          font-style: italic;
        }

        .details {
          max-width: 25em;
          margin: 0 auto;
          padding: 0.5em 0;
        }

        .price {
          font-weight: bold;
          padding-bottom: 0.5em;
        }
      }
    }

    @media(max-width: $mobile) {
      .cart {
        &, & .cartTable {
          width: 100% !important;
        }
      }

      .products {
        text-align: left;

        .product {
          display: block;

          .image {
            width: calc(100vw - 2.5em);
            height:  calc(100vw - 2.5em);
          }
        }
      }

      .modalWrapper {
        .prevProduct, .nextProduct {
          display: none;
        }

        .modal {
          &.checkout {
            width: 100%;
          }

          .imageWrapper {
            width: calc(100vw - 4em);
            height:  calc(100vw - 4em);
          }
        }
      }
    }
  }
}
</style>